<template>

	<div class="gray-bg" style="min-height: 100vh">

		<div class="middle-box text-center loginscreen   animated fadeInDown">
      <div>

        <div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
          <img src="/static/image/park_bills_text_black.png">
        </div>
        
        <h3>ParkBills - Forgot Password</h3>
        
        <form class="m-t" role="form" action="login.html">
					
					<div class="form-group">
						<input v-model="username" type="email" class="form-control" placeholder="Email" required="">
					</div>

          <h3 class="smaller lighter grey" v-show="isLoading"><i class="fa fa-spin fa-spinner"></i></h3>

          <label class="error form-control-feedback" >{{ error }} </label>
          <label class="text-info form-control-feedback" >{{ result }} </label>
					
					<button type="submit" class="btn btn-primary block full-width m-b btn-snatch" @click.prevent="handleSubmit">
						Forgot Password
					</button>

          <p class="text-muted text-center"><small>Already have an account?</small></p>
          <a class="btn btn-sm btn-white btn-block" v-bind:href="helper.WEB_URL + '/login'">Login</a>
          <a class="btn btn-sm btn-white btn-block m-t" v-bind:href="helper.WEB_URL + '/register'">Register</a>
        </form>
				
				<p class="m-t">
					<small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
				</p>

      </div>
    </div>
    
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageForgotPassword",
  data(){
    return {
      helper: helper,
      username : "",
      error : "",
      isLoading: false,
    }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
  },
  methods : {
    handleSubmit(e){
      if(this.isLoading) {
        return;
      }
      
      // e.preventDefault();
      this.isLoading = true;
      if (this.username.length > 0) {
        this.$http
        .post(helper.API_URL + '/api2/auth2/web/forgot', {
          email: this.username,
          parkbill: 1,
        })
        .then(response => {
          this.isLoading = false;
          let resultMeta = helper.processAxiosResponse(this, response);
          this.result = `Further instructions have been sent to your e-mail ${this.username}.`;
          helper.redirect(helper.WEB_URL + '/login', 3000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.error = 'Problem resetting password. ' + this.parseLoginError(error);
        });
      } else {
        this.error = 'Please fill in required info before proceed.';
      }
    },
    parseLoginError(error) {
      if(error) {
        if(error.response) {
          if(error.response.data) {
            if(error.response.data.message) {
              return error.response.data.message;
            }

            if(typeof a_string === 'string') {
              return error.response.data;
            }
          }

          if(typeof a_string === 'string') {
            return error.response;
          }
        }
      }

      return 'Please try again.'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageForgotPassword.vue